import { render, staticRenderFns } from "./positionApplicants.vue?vue&type=template&id=e984eda4&scoped=true"
import script from "./positionApplicants.vue?vue&type=script&lang=js"
export * from "./positionApplicants.vue?vue&type=script&lang=js"
import style0 from "./positionApplicants.vue?vue&type=style&index=0&id=e984eda4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e984eda4",
  null
  
)

export default component.exports